import * as Sentry from '@sentry/browser';
import axios, { AxiosHeaders, isAxiosError } from 'axios';
import { parseJwt } from '@utils/common_utils';
// TODO@saltdotac: Replace these with same-site cookies when we revise auth.
axios.defaults.headers.common['X-NNN-CSRF'] = window.nnn_csrf_token;
axios.defaults.headers.common['X-NNN-API'] = window.nnn_token;
/* If present, add the log rocket session URL to the request headers */
axios.interceptors.request.use(function (config) {
    if (window.LogRocket && window.LogRocket.sessionURL) {
        config.headers['X-NNN-LOGROCKET'] = window.LogRocket.sessionURL;
    }
    return config;
});
var MINUTE_IN_MILLISECONDS = 1000 * 60;
/**
 * Gets an active endpoints token.
 * @return {Promise} Promise that resolves to an up-to-date endpoints token.
 */
var getEndpointsToken = function () {
    if (window.nnn_endpoints_token) {
        var expireAt = parseJwt(window.nnn_endpoints_token).exp;
        var millisecondsUntilExpiration = expireAt * 1000 - Date.now();
        if (millisecondsUntilExpiration > MINUTE_IN_MILLISECONDS) {
            return Promise.resolve(window.nnn_endpoints_token);
        }
    }
    return axios
        .get('/api/auth/token/endpoints')
        .then(function (_a) {
        var data = _a.data;
        // Update the global variable endpointsToken
        window.nnn_endpoints_token = data.endpointsToken;
        return data.endpointsToken;
    })
        .catch(function (error) {
        Sentry.captureException(error);
        return Promise.reject(error);
    });
};
/**
 * Gets an active endpoints token.
 * @return {function} a new axios instance with auth header.
 */
var createAxiosInstanceWithAuthHeader = function () {
    var axiosInstance = axios.create();
    axiosInstance.interceptors.request.use(function (config) {
        return getEndpointsToken()
            .then(function () {
            config.headers = {
                Authorization: "Bearer ".concat(window.nnn_endpoints_token),
            };
            return config;
        })
            .catch(function () {
            // If failed to refresh endpointsToken, use the previous endpointsToken.
            // If it expired, we will likely see "Jwt is expired" alert
            // and it's more helpful than aborting the request.
            config.headers = {
                Authorization: "Bearer ".concat(window.nnn_endpoints_token),
            };
            return config;
        });
    }, Sentry.captureException);
    return axiosInstance;
};
var getErrorMessagesFromAxiosErrorResponse = function (error) {
    if (isAxiosError(error) && error.response) {
        var _a = error.response, data = _a.data, headers = _a.headers, status_1 = _a.status;
        if (headers instanceof AxiosHeaders && headers.has('grpc-message')) {
            Sentry.captureMessage(headers['grpc-message']);
        }
        if (data && data.errors) {
            return data.errors;
        }
        else if (status_1 === 403) {
            return ['Permission denied'];
        }
        else if (status_1 === 503) {
            return ['Service unavailable'];
        }
        else {
            return ["Request failed with status code ".concat(status_1)];
        }
    }
    else {
        return ['Unexpected error from server'];
    }
};
var getErrorDataFromAxiosErrorResponse = function (error) {
    if (isAxiosError(error) && error.response && error.response.data) {
        return error.response.data.data;
    }
};
export { axios as default, createAxiosInstanceWithAuthHeader, getEndpointsToken, getErrorMessagesFromAxiosErrorResponse, getErrorDataFromAxiosErrorResponse, };
